/* Kloopp — ficha de producto: cantidad, galería y cambio de variante.
   Sin JS la página se ve y se puede comprar la variante inicial. */
(function () {
  var root = document.querySelector('[data-product]');
  if (!root) return;

  /* Cantidad */
  var qty = root.querySelector('[data-qty]');
  function clamp() {
    var n = parseInt(qty.value, 10);
    qty.value = isNaN(n) ? 1 : Math.min(99, Math.max(1, n));
  }
  root.querySelectorAll('[data-qty-step]').forEach(function (button) {
    button.addEventListener('click', function () {
      qty.value = (parseInt(qty.value, 10) || 1) + parseInt(button.getAttribute('data-qty-step'), 10);
      clamp();
    });
  });
  qty.addEventListener('change', clamp);

  /* Galería */
  var main = root.querySelector('[data-main-img]');
  var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-thumb]'));
  function showThumb(thumb) {
    if (!main || !thumb) return;
    main.src = thumb.getAttribute('data-src');
    main.srcset = thumb.getAttribute('data-srcset');
    main.alt = thumb.getAttribute('data-alt') || '';
    thumbs.forEach(function (t) {
      t.setAttribute('aria-current', t === thumb ? 'true' : 'false');
    });
  }
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      showThumb(thumb);
    });
  });

  /* Variantes */
  /* La barra fija móvil y el JSON están fuera de [data-product], pero dentro de la misma sección */
  var scope = root.closest('.shopify-section') || document;
  var dataEl = scope.querySelector('[data-variants]');
  var groups = root.querySelectorAll('[data-option]');
  if (!dataEl || !groups.length) return;

  var variants = JSON.parse(dataEl.textContent);
  var idInput = scope.querySelector('[data-variant-id]');
  var stock = scope.querySelector('[data-stock]');
  var compare = scope.querySelectorAll('[data-compare]');
  var discount = scope.querySelectorAll('[data-discount]');
  var sku = scope.querySelector('[data-sku]');
  var addButtons = scope.querySelectorAll('[data-add]');
  var buyNow = scope.querySelector('[data-buynow]');

  function selectedValues() {
    return Array.prototype.map.call(groups, function (group) {
      var checked = group.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  function findVariant(values) {
    return variants.filter(function (v) {
      return v.options.every(function (option, i) {
        return option === values[i];
      });
    })[0];
  }

  function setText(nodes, text) {
    Array.prototype.forEach.call(nodes, function (el) {
      el.textContent = text;
    });
  }

  function render(variant) {
    var available = !!(variant && variant.available);

    if (variant) {
      idInput.value = variant.id;
      setText(scope.querySelectorAll('[data-price]'), variant.price);
      Array.prototype.forEach.call(compare, function (el) {
        el.hidden = !variant.compare;
        el.textContent = variant.compare || '';
      });
      Array.prototype.forEach.call(discount, function (el) {
        el.hidden = !variant.discount;
        el.textContent = variant.discount ? '-' + variant.discount + '%' : '';
      });
      if (sku) sku.textContent = variant.sku ? ' · SKU ' + variant.sku : '';

      if (variant.image_id) {
        showThumb(root.querySelector('[data-thumb][data-image-id="' + variant.image_id + '"]'));
      }

      try {
        history.replaceState(null, '', location.pathname + '?variant=' + variant.id);
      } catch (e) {
        /* sin historial disponible: la variante igual queda elegida en el formulario */
      }
    }

    if (stock) {
      stock.classList.toggle('is-out', !available);
      stock.querySelector('span').textContent = variant
        ? available ? stock.getAttribute('data-in') : stock.getAttribute('data-out')
        : stock.getAttribute('data-none');
    }

    Array.prototype.forEach.call(addButtons, function (button) {
      button.disabled = !available;
      button.textContent = available ? button.getAttribute('data-label') : button.getAttribute('data-label-out');
    });
    if (buyNow) buyNow.disabled = !available;
  }

  root.addEventListener('change', function (event) {
    if (event.target.closest('[data-option]')) render(findVariant(selectedValues()));
  });
})();
